module.exports = __webpack_public_path__ + "img/jsfw.a39157e3.png";